import { Injectable } from '@angular/core';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import {
  IInstantWebsiteSettings,
  IInstantWebsiteSettingsData,
  INSTANT_WEBSITE_SETTINGS_ACCEPT_VERSION,
} from './instant-website-data.data';
import { Observable } from 'rxjs/internal/Observable';
import { IResponseInfo, LoggerService, serialize } from 'i2g-ng-utils';
import { map } from 'rxjs/operators';

interface IInstantWebsiteDataBody {
  settings: IInstantWebsiteSettings;
}

@Injectable()
export class InstantWebsiteDataService {
  protected _settingsHeaders: any = {
    [ACCEPT_VERSION_HEADER]: INSTANT_WEBSITE_SETTINGS_ACCEPT_VERSION,
  };

  instantWebsiteSettingsUrl = '/business/website/settings';

  constructor(
    private _authHttpService: AuthHttpService,
    private _loggerService: LoggerService
  ) {}

  fetchInstantWebsiteSettings(): Observable<IInstantWebsiteSettings> {
    this._loggerService.log('getting instant website settings from network');
    return this._authHttpService
      .get(this.instantWebsiteSettingsUrl, null, this._settingsHeaders)
      .pipe(
        map(
          ({ body }: IResponseInfo) =>
            (body as IInstantWebsiteDataBody).settings
        )
      );
  }

  saveInstantWebsiteSettings(
    settings: IInstantWebsiteSettingsData
  ): Observable<IInstantWebsiteSettings> {
    this._loggerService.log(
      'saving instant website settings:',
      settings,
      'to network'
    );
    return this._authHttpService
      .put(
        this.instantWebsiteSettingsUrl,
        serialize(settings),
        this._settingsHeaders
      )
      .pipe(
        map(
          ({ body }: IResponseInfo) =>
            (body as IInstantWebsiteDataBody).settings
        )
      );
  }
}
